import { SmscObject } from '../../../../models/smscModel';
import SmscForm from '../../components/smsc/SmscForm';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { VersionableId } from '../../../../types/versionableId';
import { SchemaModel } from '../../../../models/schemaModel';
import { selectSmscByVersionableId } from '../../../../store/smsc/smscSelector';
import SmscApi from '../../../../api/smscApi';
import { fetchSchemaByName } from '../../../../store/schemas/schemasActions';
import { AppErrorList, useAppErrorList } from '../../../../shared/components/AppErrorList';

type Props = {
  readonly schema: SchemaModel;
  readonly smscId: VersionableId;
  readonly hideSmscForm: () => void;
};

const SmscEditFormContainer = (props: Props) => {
  const { schema, smscId, hideSmscForm } = props;

  const dispatch = useAppDispatch();
  const [{ errors, hasErrors }, { addError, removeError }] = useAppErrorList();
  const smsc = useAppSelector(state => selectSmscByVersionableId(state, smscId));

  const handleEditSmsc = (smsc: SmscObject) => {
    const schemaName = schema.name;
    const smscName = smscId.resourceName;

    SmscApi.updateSmsc(schemaName, smscName, smsc)
      .then(() => {
        dispatch(fetchSchemaByName(schemaName));
        hideSmscForm();
      })
      .catch(addError);
  };

  const initialValues = {
    ...smsc?.object,
  };

  return (
    <>
      { hasErrors && (
        <AppErrorList
          errors={errors}
          onCloseError={removeError}
        />
      )}

      <SmscForm
        title='Edit smsc'
        smscId={smscId}
        initialValues={initialValues}
        onSubmit={handleEditSmsc}
        onCancel={hideSmscForm}
        readOnly={false}
      />
    </>
  );
}

export default SmscEditFormContainer;
